<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div
        menuSystem
        [cerrixTab]="tab"
        class="details"
        (changeEvent)="handleMenuItemClick($event)"
        data-uiid="audit-universe-detail-page"
    >
        <div class="detail-page-action-bar">
            @if (!readonly) {
                <button class="btn btn-cerrix" data-uiid="save-audit-universe" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span data-uiid="save" class="d-none d-lg-inline">{{
                        "detail.saveObject" | t
                    }}</span>
                </button>
            }

            @if (historicalView) {
                <span class="sub-message">
                    Viewing historical readonly data. Audit object from
                    {{ model.dateUpdated | dateFormat }}
                </span>
            } @else if (model.id > 0) {
                <span class="date-edited">
                    Last save: {{ model.dateUpdated | dateTimeFormat }}
                </span>
            }

            @if (permissions.canChangeDate) {
                <div class="right-area">
                    <date-input
                        [(value)]="dateFilter"
                        [maxDate]="dateFilterMax"
                        (valueChange)="dateChanged()"
                    ></date-input>
                </div>
            }
        </div>

        <div
            class="screens"
            menuItemId="menuItemUniverseObject"
            [attr.name]="'detail.menuUniverseObject' | t"
            menuicon="fad fa-planet-ringed"
            menusystemsubmenu
        >
            <div
                menuItemId="menuItemDetails"
                [attr.name]="'detail.menuDetails' | t"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <audit-universe-detail-main
                    [permissions]="permissions"
                    [standingData]="standingData"
                    [model]="model"
                    [formGroup]="formGroup"
                ></audit-universe-detail-main>
            </div>
            @if (permissions.canViewRelatedData) {
                <div
                    [attr.name]="'detail.menuRelatedData' | t"
                    [attr.menuItemId]="menuItemData"
                    menuicon="fad fa-planet-ringed"
                    menusystemitem
                >
                    <audit-universe-data
                        [organizations]="model.organizations"
                        [businessDimensions]="model.businessDimensions"
                        [frameworkDimensions]="model.frameworkDimensions"
                        [dateFilter]="dateFilter"
                        [manualMode]="true"
                        #moduleDataComp
                    ></audit-universe-data>
                </div>
            }
            @if (model.id > 0) {
                <div
                    menuItemId="menuItemLinks"
                    [attr.name]="'detail.menuLinks' | t"
                    menuicon="fas fa-link"
                    menusystemsubmenu
                >
                    @if (permissions.canViewLinkedAudits) {
                        <div
                            [attr.name]="'detail.menuAudits' | t"
                            [attr.menuItemId]="menuItemAudits"
                            menuicon="fal fa-clipboard-list-check"
                            menusystemitem
                        >
                            <audit-universe-linked-audits
                                #auditsComponent
                                [auditUniverseModel]="model"
                                [parentForm]="formGroup"
                                [disabled]="!permissions.canLinkAudits"
                            >
                            </audit-universe-linked-audits>
                        </div>
                    }
                    @if (permissions.canViewLinkedForms) {
                        <div
                            [attr.menuItemId]="menuItemForms"
                            [attr.name]="'detail.menuForms' | t"
                            menuicon="fas fa-file-alt"
                            menusystemitem
                        >
                            <audit-universe-linked-forms
                                #formsComponent
                                [model]="model"
                                [disabled]="!permissions.canLinkForms"
                            ></audit-universe-linked-forms>
                        </div>
                    }
                    @if (permissions.canViewDocuments) {
                        <div
                            [attr.name]="'detail.menuDocuments' | t"
                            [attr.menuItemId]="menuItemDocuments"
                            menuicon="far fa-file"
                            menusystemitem
                        >
                            @if (documents) {
                                <document-manager
                                    [(Documents)]="model.Documents"
                                    (DocumentsChange)="checkDocumentsDirty()"
                                    [permissions]="permissions.documentPermissions"
                                    [DocumentTypeTargets]="targetModule"
                                >
                                </document-manager>
                            } @else {
                                <div class="fancy-loader"></div>
                            }
                        </div>
                    }
                </div>
            }
            @if (permissions.canViewHistory) {
                <div
                    [attr.name]="'detail.menuHistory' | t"
                    [attr.menuItemId]="menuItemHistory"
                    menuicon="fas fa-history"
                    menusystemitem
                >
                    @if (id) {
                        <app-history-overview
                            [historyDataService]="_ds"
                            [Id]="id"
                            #historyOverviewComponent
                        >
                        </app-history-overview>
                    }
                </div>
            }
            @if (model.id > 0) {
                <div
                    menuItemId="menuItemOptions"
                    [attr.name]="'detail.menuOptions' | t"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="Universe Object"
                        [objectName]="model.name"
                        [allowDelete]="permissions.canDelete"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
